import type { SelfHostConfig } from "./WebTransport";
import { storedLocalApiPort } from "../lib/localApi";

/**
 * Resolves selfhost server configuration for streaming.
 * Fetches from /api/server-remote, filtering for type="selfhost" only.
 */
class SelfHost {
  private config: SelfHostConfig | null = null;

  async resolve(): Promise<SelfHostConfig | null> {
    const port = storedLocalApiPort();
    if (!port) return null;

    try {
      const response = await fetch(`http://localhost:${port}/api/server-remote`);
      if (!response.ok) return null;

      const result = await response.json();
      const data = result?.data;
      const allServers = Array.isArray(data?.servers) ? data.servers : [];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const servers = allServers.filter((s: any) => !s.type || s.type === "selfhost");
      if (servers.length === 0) return null;

      const activeId = data?.activeServerId;
      const activeServer =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (activeId ? servers.find((s: any) => s.id === activeId) : null) || servers[0];
      if (!activeServer?.host) return null;

      this.config = {
        id: activeServer.id || `selfhost-${Date.now()}`,
        host: activeServer.host,
        username: activeServer.username || "",
        password: activeServer.password || "",
        timestamp: typeof activeServer.timestamp === "number" ? activeServer.timestamp : Date.now(),
      };

      return this.config;
    } catch (error) {
      console.warn("SelfHost - Could not fetch config from extension:", error);
      return null;
    }
  }

  getConfig(): SelfHostConfig | null {
    return this.config;
  }
}

export default SelfHost;
